import _ from 'underscore';

import { addMessageToFieldConfig } from '../message-mapper';

export class NewFields {
  constructor({
    i18n,
    isPageFeedEnabled,
    isGoogleImageExtensionImportOptionEnabled,
    isGoogleLogoExtensionImportOptionEnabled,
    isGoogleAccountNegativeKeywordsImportOptionEnabled,
    isGoogleConversionGoalsImportOptionEnabled,
    isBrandSuitabilityImportOptionEnabled,
  }) {
    this.i18n = i18n;
    this.isPageFeedEnabled = isPageFeedEnabled;

    this.importItemsFields = _.compact([
      {
        property: 'ImportNewOption_ImportNewCampaignsAndChildEntities',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewAdGroupsAndChildEntitiesForExistingCampaigns',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewAdsForExistingAdGroups',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewKeywordsForExistingAdGroups',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewNegativeKeywordsForExistingParents',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewNegativeKeywordList',
        showLabel: false,
      },
      isGoogleAccountNegativeKeywordsImportOptionEnabled && {
        property: 'ImportNewOption_ImportNewAccountNegativeKeywords',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewKeywordUrls',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewTrackingTemplateAndCustomParams',
        message: i18n.getString('Import_ImportOptions_TrackingTemplateCustomParams_FinalURLSuffix'),
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewNegativeSites',
        showLabel: false,
      },
      {
        property: 'ImportNewLabelsAndAssociations',
        message: this.i18n.getString('Import_ImportOptions_ImportNewLabelsAndAssociations'),
        showLabel: false,
      },
      {
        property: 'ImportNewCustomFiltersForShoppingCampaigns',
        message: this.i18n.getString('Import_ImportOptions_ImportNewCustomFiltersForShoppingCampaigns'),
        showLabel: false,
      },
      isBrandSuitabilityImportOptionEnabled && {
        property: 'ImportNewOption_ImportNewBrandSuitability',
        message: this.i18n.getString('Import_ImportOptions_BrandSuitabilityImportOption'),
        showLabel: false,
      },
    ]);

    this.newTargetingFields = _.compact([
      {
        property: 'ImportNewOption_ImportNewLocationTargets',
        label: this.i18n.getString('Import_ImportOptions_LocationTarget'),
        showLabel: false,
        message: this.i18n.getString('ImportNewOption_ImportNewLocationTargets'),
      },
      {
        property: 'ImportNewOption_ImportNewDayTimeTargets',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewDeviceTargets',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewDemographicTargets',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewAudienceTargets',
        showLabel: false,
        message: this.i18n.getString('Import_ImportOptions_AudienceListsAndTargets'),
      },
    ]);

    this.newAdExtensionFields = _.compact([
      {
        property: 'ImportNewOption_ImportNewAppAdExtensions',
        label: this.i18n.getString('Import_ImportOptions_AdExtensions'),
        showLabel: false,
        message: this.i18n.getString('ImportNewOption_ImportNewAppAdExtensions'),
      },
      {
        property: 'ImportNewOption_ImportNewCallAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewCalloutAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewLocationAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewPriceAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewPromotionAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewReviewAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewSitelinkAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewStructuredSnippetAdExtensions',
        showLabel: false,
      },
      isGoogleImageExtensionImportOptionEnabled && {
        property: 'ImportNewOption_ImportNewImageAdExtensions',
        showLabel: false,
      },
      isGoogleLogoExtensionImportOptionEnabled && {
        property: 'ImportNewOption_ImportNewLogoAdExtensions',
        showLabel: false,
      },
    ]);

    this.newFeedFields = _.compact([
      this.isPageFeedEnabled && {
        property: 'ImportNewOption_ImportNewPageFeeds',
        showLabel: false,
      },
      {
        property: 'ImportNewOption_ImportNewAdCustomizerFeeds',
        showLabel: false,
      },
    ]);

    this.newConversionFields = isGoogleConversionGoalsImportOptionEnabled
      ? [{
        property: 'ImportNewOption_ImportNewConversionGoals',
        showLabel: false,
      }]
      : [];

    addMessageToFieldConfig(
      this.i18n,
      this.importItemsFields,
      this.newTargetingFields,
      this.newAdExtensionFields,
      this.newFeedFields,
      this.newConversionFields
    );
  }

  getImportItemsFields() {
    return this.importItemsFields;
  }

  getNewTargetingFields() {
    return this.newTargetingFields;
  }

  getNewAdExtensionFields() {
    return this.newAdExtensionFields;
  }

  getNewFeedFields() {
    return this.newFeedFields;
  }

  getNewConversionFields() {
    return this.newConversionFields;
  }
}

